import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { spacing20 } from 'approot/shared/styles/spacing.style';
import {
  SecondaryButton,
  SecondaryButtonLink,
} from 'approot/shared/styles/buttons/secondary-button.style';
import { boxShadow815Grey } from 'approot/shared/styles/borders.style';
import { PrimaryButton } from 'approot/shared/styles/buttons/primary-button.style';
import { grey1 } from 'approot/shared/styles/colours.style';

export const ConclusionView = styled.div`
  ${flexCentreAlignCss}
  flex-direction: column;
  padding-top: ${rem(40)};
`;

type ConclusionWrapperProps = {
  $isSmall: boolean;
};
export const ConclusionWrapper = styled.div<ConclusionWrapperProps>`
  margin-bottom: ${rem(spacing20)};
  max-width: ${({ $isSmall }) => rem($isSmall ? 400 : 540)};
  position: relative;
  width: 100%;
`;

export const ConclusionCheck = styled.div`
  width: ${rem(120)};
  height: ${rem(120)};
  position: absolute;
  right: -${rem(30)};
  bottom: -${rem(40)};
  img {
    width: 100%;
  }
`;

export const ConclusionButton = styled(SecondaryButtonLink).attrs({
  $borderRadius: 80,
  $isLarge: true,
})`
  ${boxShadow815Grey}
`;

export const ConclusionCompleteButton = styled(PrimaryButton)`
  ${boxShadow815Grey}
  svg {
    path {
      stroke: ${grey1};
      fill: none;
    }
  }
`;

export const ConclusionIncompleteButton = styled(SecondaryButton)`
  ${boxShadow815Grey}
`;
